// extracted by mini-css-extract-plugin
export var baseButton = "_qi-0";
export var controlsArrowKeys = "_qi-1";
export var controlsResetButton = "_qi-2";
export var lightGameButton = "_qi-4 _qi-0";
export var playAgainButton = "_qi-5 _qi-0";
export var startGameButton = "_qi-3 _qi-0";